import { IconButton, Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import ChevronLeftIcon from '../../../../assets/icons/ChevronLeft.svg?react'
import ChevronRightIcon from '../../../../assets/icons/ChevronRight.svg?react'

const PaginationButton = styled(IconButton)(({ theme }) => ({
    width: '24px',
    height: '24px',
    padding: '4px',
    color: '#5A5F72',
}))

type Props = {
    currentIndex: number
    total: number
    onChange?: (index: number) => void
}

export const AnswerVariantsControls: FC<Props> = ({ currentIndex, total, onChange }) => {
    const handleChangeIndex = (newIndex: number) => {
        onChange?.(newIndex)
    }

    const handlePrev = () => handleChangeIndex(currentIndex - 1)

    const handleNext = () => handleChangeIndex(currentIndex + 1)

    const indexToDisplay = currentIndex + 1

    return (
        <Stack direction="row" alignItems="center">
            <PaginationButton disabled={indexToDisplay <= 1} onClick={handlePrev}>
                <ChevronLeftIcon />
            </PaginationButton>
            <Typography variant="caption2" color="#5A5F72">
                {indexToDisplay} / {total}
            </Typography>
            <PaginationButton disabled={indexToDisplay >= total} onClick={handleNext}>
                <ChevronRightIcon />
            </PaginationButton>
        </Stack>
    )
}
